<template>
  <div>
    <div style="float: left;">
      <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="$emit('toggleCollapsed')" />
    </div>
    <div style="float: right;">
      <!-- <a-dropdown :trigger="['click']">
        <span class="trigger">
          {{currentWarehouse}}
          <a-icon type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item v-for="item in warehouseItems" :key="item.id" @click="onChangeWarehouse(item)">
            <span>{{item.name}}</span>
          </a-menu-item>
        </a-menu>
        </a-dropdown>
        -->
      <!--a-dropdown :trigger="['click']">
        <span class="trigger">
          客服
        </span>
        <a-menu slot="overlay">
          <a-menu-item>
            <img :src="wechatCustomerService" width="80" style="margin-top: -6px;" />
          </a-menu-item>
          <a-menu-divider />
        </a-menu>
      </a-dropdown-->
      <a-dropdown :trigger="['click']">
        <span class="trigger" @click=checkExpress2()>
          APP下载
        </span>
      </a-dropdown>
      <a-dropdown :trigger="['click']">
        <span class="trigger" @click=checkExpress1()>
          插件下载
        </span>
      </a-dropdown>
      <a-dropdown :trigger="['click']">
        <span class="trigger" @click=checkExpress()>
          帮助中心
        </span>
      </a-dropdown>
      <!--a-dropdown :trigger="['click']">
        <span class="trigger" @click="$router.push('/recharge')">
          充值
        </span>
      </a-dropdown-->
      <a-dropdown :trigger="['click']">
        <span class="trigger">
          {{username}}
          <a-icon type="down" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item @click="$router.push('/set_password')">
            <span>修改密码</span>
          </a-menu-item>
          <!--a-menu-divider /-->
          <a-menu-item @click="logout">
            <span>退出登录</span>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
// import { warehouseOption } from '@/api/option';
import Cookies from 'js-cookie';


export default {
  name: 'Headbar',
  props: ['collapsed', 'username'],
  inject: ['reloadPage'],
  data () {
    return {
      warehouseItems: [],
      currentWarehouse: '所有仓库',
      wechatCustomerService: require('@/assets/wechat_customer_service.png'),
      show: false
    };
  },
  methods: {
    initData () {
      // warehouseOption({ page_size: 1000000 }).then(data => {
      //   console.log(data.results)
      //   this.warehouseItems = [{ id: undefined, name: '所有仓库' }, ...data.results];
      // });
    },
    logout () {
      Cookies.remove('access');
      Cookies.remove('refresh');
      this.$router.push('/login');
    },
    onChangeWarehouse (item) {
      this.currentWarehouse = item.name;
      this.$store.commit('setWarehouse', item.id);
      this.reloadPage();
    },
    showImage () {
      this.show = true;
    },
    checkExpress () {
      window.open('http://1.94.209.95/strategy/汇量化插件使用说明.pdf', "_blank")
    },
    checkExpress1 () {
      window.open('http://1.94.209.95/strategy/汇量化插件.rzrk', "_blank")
    },
    checkExpress2 () {
      //window.location.href = 'https://1.94.209.95/app/汇量化.apk';
      window.open('http://1.94.209.95/app/汇量化.apk', "_blank")
    },
  },
  mounted () {
    this.initData();
  },
}
</script>

<style scoped>
.trigger {
  font-size: 15px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

.trigger:hover {
  color: #1890ff;
}
</style>